import { Bot, UserCog, Lock, type LucideIcon } from "lucide-react";
import type { ConversationMode } from "@/lib/conversations";

const MODE_BADGE_CONFIG: Record<
  ConversationMode,
  { label: string; className: string; icon: LucideIcon }
> = {
  bot: {
    label: "Bot",
    className: "bg-blue-50 text-blue-700 border border-blue-200",
    icon: Bot,
  },
  human: {
    label: "Atendiendo persona",
    className: "bg-amber-50 text-amber-700 border border-amber-200",
    icon: UserCog,
  },
  closed: {
    label: "Cerrada",
    className: "bg-gray-100 text-gray-600 border border-gray-200",
    icon: Lock,
  },
};

/** Badge de modo (bot/humano/cerrada), compartido entre el inbox del
 *  inquilino y el inbox de soporte de plataforma. */
export default function ConversationModeBadge({
  mode,
}: {
  mode: ConversationMode;
}) {
  const config = MODE_BADGE_CONFIG[mode];
  const Icon = config.icon;
  return (
    <span
      className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium flex-shrink-0 ${config.className}`}
    >
      <Icon className="w-3 h-3" />
      {config.label}
    </span>
  );
}
